module.exports = __webpack_public_path__ + "05983c2876d5f1ac7eda65bbfd00b3a9.jpg";